

































import axios from 'axios'
import edit_rule from "@/components/edit_rule.vue";
import {Mixins, Component} from "vue-property-decorator";
import att_mixins from "../../mixins/att";

@Component({components: {edit_rule}})
export default class user_access extends Mixins(att_mixins) {
    columns = [
        {
            title: 'ID',
            key: 'ID',
            width: 85,
            sortable: true
        },
        {
            title: '用户名',
            key: 'Username',
            sortable: true
        },
        {
            title: '操作',
            key: 'action',
            align: 'center',
            slot: 'action'
        }
    ];
    rule_form = {
        username: '',
        group: []
    };

    edit_rule(vl: { Username: string; Group: never; }) {
        this.rule_form = {
            username: vl.Username,
            group: vl.Group
        };
        this.is_open = true;
    }

    current_page(vl = 1) {
        axios.get(`${this.$config.url}/group?page=${vl}&con=${JSON.stringify(this.query)}`)
            .then(res => {
                this.table_data = res.data.data;
                this.group_list = res.data.group_list;
                this.page_number = parseInt(res.data.page);
            })
            .catch(error => {
                this.$config.err_notice(this, error)
            })
    }

    queryData() {
        this.query.valve = true;
        this.current_page()
    }

    queryCancel() {
        this.$config.clearObj(this.formItem);
        this.current_page()
    }

    cancel() {
        this.is_open = false;
        this.rule_form.group = []
    }

    post_ok() {
        this.current_page(this.current)
    }

    mounted() {
        this.current_page()
    }
}
